import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/content';
function Stars({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`flex gap-1 text-terra-star ${className}`} role="img" aria-label="5 de 5 estrellas" data-id="element-187" data-mp="3ksqdz2uth84w">
      {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-5 w-5 fill-current" strokeWidth={0} aria-hidden="true" data-id="element-188" data-mp="3b148ln55u3a2" />)}
    </div>;
}
export function Testimonials() {
  return <section className="bg-paper py-20 sm:py-28" aria-labelledby="testimonials-title" style={{
    paddingTop: "24px"
  }} data-id="element-189" data-mp="370ajiqfzeifl">
      <div className="mx-auto max-w-[880px] px-5 sm:px-8" data-id="element-190" data-mp="32290g5ik2j44">
        <div className="text-center" data-id="element-191" data-mp="2x1kyiossghv4">
          
          <Stars className="mt-5 justify-center" data-id="element-192" data-mp="2s1q9kqskq2cp" />
          <h2 id="testimonials-title" className="mt-4 font-display text-[2.2rem] leading-tight text-petrol sm:text-5xl" data-id="element-193" data-mp="2s308fi793eke">
            Testimonios de profesionales
          </h2>
        </div>

        <ul className="mt-14 space-y-6" data-id="element-194" data-mp="qbeujcca6lif">
          {testimonials.map(t => <li key={t.name} className="rounded-[2rem] bg-cream/70 px-7 py-9 sm:px-12 sm:py-12" data-id="element-195" data-mp="h67z23dntm9u">
              <Stars data-id="element-196" data-mp="m4rmy9btd84u" />
              <blockquote className="mt-6 font-display text-[1.4rem] italic leading-[1.4] text-petrol sm:text-[1.7rem]" data-id="element-197" data-mp="m5b2xkhwlmg8">
                “{t.quote}”
              </blockquote>
              <p className="mt-8 font-semibold text-petrol" data-id="element-198" data-mp="c6ll1rq0c1zz">{t.name}</p>
              <p className="mt-1 text-sm text-ink-mute" data-id="element-199" data-mp="c8y304vrmcd1">{t.role}</p>
            </li>)}
        </ul>
      </div>
    </section>;
}